import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';

import useExperimentVariant from 'hooks/useExperimentVariant';
import useRouterHashTag from 'hooks/useRouterHashTag';

import { PRICE_COMPARATOR_EXPERIMENT_ID } from 'lib/experiment';
import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import GoToStoreButton from './GoToStoreButton';
import FinishedOfferButtons from './GoToStoreButton/FinishedOfferButtons';

import OFFER from 'constants/offer';

const ActionButton = ({
  gaEventCategory,
  isFinished,
  isShowingPriceHistory,
  mostRelevantKeyword,
  offerCoupon = null,
  offerCta,
  offerId,
  offerSlug,
  offersToCompare = [],
  offerUserVisibility,
}) => {
  const [isShowingVariantC] = useExperimentVariant(
    PRICE_COMPARATOR_EXPERIMENT_ID,
    [false, false, true],
    {
      fallback: { outOfDateValue: false },
    }
  );
  const { setHashTag } = useRouterHashTag(OFFER.PRICE_COMPARATOR_HASH_TAG);
  const isShowingPriceComparatorButton =
    isShowingVariantC && offersToCompare.length > 0;

  const onComparePricesClick = () => {
    setHashTag(true);
    sendEvent({
      action: 'click_cta_compare',
      category: gaEventCategory,
    });
  };

  if (isFinished) {
    return (
      <FinishedOfferButtons
        gaEventCategory={gaEventCategory}
        mostRelevantKeyword={mostRelevantKeyword}
        offerId={offerId}
        offerSlug={offerSlug}
        offerUserVisibility={offerUserVisibility}
      />
    );
  }

  const GoToStoreComponent = (
    <GoToStoreButton
      gaEventCategory={gaEventCategory}
      offerCoupon={offerCoupon}
      offerCta={offerCta}
      offerId={offerId}
      offerSlug={offerSlug}
      offerUserVisibility={offerUserVisibility}
    />
  );

  if (isShowingPriceHistory || !isShowingPriceComparatorButton) {
    return GoToStoreComponent;
  }

  return (
    <div className="flex flex-col gap-2 lg:flex-row lg:gap-4">
      {GoToStoreComponent}
      <Button
        className="lg:w-1/3"
        type="primary-stroke"
        full
        onClick={onComparePricesClick}
      >
        {placeholder('actions.comparePrices')}
      </Button>
    </div>
  );
};

ActionButton.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  isFinished: PropTypes.bool.isRequired,
  isShowingPriceHistory: PropTypes.bool.isRequired,
  mostRelevantKeyword: PropTypes.string.isRequired,
  offerCoupon: PropTypes.string,
  offerCta: PropTypes.string,
  offerId: PropTypes.number.isRequired,
  offerSlug: PropTypes.string.isRequired,
  offersToCompare: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
      redirect: PropTypes.string.isRequired,
      created: PropTypes.string.isRequired,
      store: PropTypes.shape({
        domain: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        image: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      }),
    })
  ),
  offerUserVisibility: PropTypes.string.isRequired,
};

export default ActionButton;
